import { SvgIcon, type SvgIconProps } from "@mui/material";
import { type FC, type PropsWithChildren } from "react";

const Delete: FC<PropsWithChildren<SvgIconProps>> = (props) => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            fillRule="evenodd"
            d="M5.375,0.888888889 L1,0.888888889 L1,2.66666667 L1.875,2.66666667 L1.875,14.2222222 C1.875,15.2040618 2.65850169,16 3.625,16 L12.375,16 C13.3414983,16 14.125,15.2040618 14.125,14.2222222 L14.125,2.66666667 L15,2.66666667 L15,0.888888889 L10.625,0.888888889 L10.625,0 L5.375,0 L5.375,0.888888889 Z M12.375,2.66666667 L12.375,14.2222222 L3.625,14.2222222 L3.625,2.66666667 L12.375,2.66666667 Z M5.375,12.4444444 L7.125,12.4444444 L7.125,4.44444444 L5.375,4.44444444 L5.375,12.4444444 Z M8.875,4.44444444 L8.875,12.4444444 L10.625,12.4444444 L10.625,4.44444444 L8.875,4.44444444 Z"
        />
    </SvgIcon>
);

export default Delete;
